import React from 'react';
import { Link } from 'react-router-dom';
import '../scss/whatsapp-edevcode.scss';

export default function WhatsAppEdevcodePrivacy() {
  return (
    <main className="wec-legal-page">
      <div className="wec-legal-container">
        <Link className="wec-back-link" to="/whatsapp">
          Voltar para /whatsapp
        </Link>

        <h1>Política de Privacidade</h1>
        <p>
          Esta Política de Privacidade descreve como a empresa 54.240.100
          EMERSON DE FARIAS SANTOS (eDevCode), CNPJ 54.240.100/0001-14, trata
          os dados pessoais coletados no hotsite e nos serviços de integração
          com a API oficial do WhatsApp.
        </p>

        <h2>1. Controlador dos dados</h2>
        <p>
          Razão social: 54.240.100 EMERSON DE FARIAS SANTOS
          <br />
          CNPJ: 54.240.100/0001-14
          <br />
          Endereço: Avenida Cuiabá, 95, APT 401, Planalto Boa Esperança,
          João Pessoa/PB, CEP 58065-048
          <br />
          Contato: emerson.farias@esdevcode.com.br
        </p>

        <h2>2. Dados que coletamos</h2>
        <p>Podemos coletar os seguintes dados informados por você:</p>
        <ul>
          <li>Nome e nome da empresa</li>
          <li>Email e telefone/WhatsApp para contato comercial</li>
          <li>Informações sobre volume de mensagens e necessidades do projeto</li>
          <li>Dados técnicos de acesso e navegação (logs e métricas)</li>
        </ul>

        <h2>3. Finalidade do tratamento</h2>
        <ul>
          <li>Responder solicitações comerciais e enviar propostas</li>
          <li>Executar serviços contratados de integração e suporte</li>
          <li>Melhorar desempenho, segurança e estabilidade da plataforma</li>
          <li>Cumprir obrigações legais e regulatórias</li>
        </ul>

        <h2>4. Base legal (LGPD)</h2>
        <p>
          O tratamento dos dados ocorre com base no consentimento, execução de
          contrato, interesse legítimo e cumprimento de obrigação legal,
          conforme aplicável a cada situação.
        </p>

        <h2>5. Compartilhamento de dados</h2>
        <p>
          Os dados podem ser compartilhados com fornecedores técnicos
          necessários à prestação do serviço, como provedores de infraestrutura,
          envio de mensagens e ferramentas de suporte, sempre com medidas de
          segurança e confidencialidade.
        </p>

        <h2>6. Retenção e segurança</h2>
        <p>
          Armazenamos os dados apenas pelo tempo necessário para cumprir as
          finalidades desta política e obrigações legais. Aplicamos controles
          de acesso, criptografia e práticas de segurança compatíveis com o
          tipo de operação.
        </p>

        <h2>7. Direitos do titular</h2>
        <p>
          Você pode solicitar confirmação de tratamento, acesso, correção,
          anonimização, portabilidade, revogação do consentimento e exclusão
          dos dados, nos limites da legislação aplicável.
        </p>

        <h2>8. Cookies e tecnologias similares</h2>
        <p>
          Utilizamos cookies essenciais para funcionamento do site e métricas de
          navegação para melhoria contínua da experiência.
        </p>

        <h2>9. Comunicação com a Meta e WhatsApp</h2>
        <p>
          As integrações com a API oficial do WhatsApp seguem as políticas
          vigentes da Meta. O uso dos serviços depende da conformidade do
          cliente com essas políticas e com a legislação de proteção de dados.
        </p>

        <h2>10. Atualizações desta política</h2>
        <p>
          Esta política pode ser atualizada a qualquer momento para refletir
          mudanças legais, técnicas ou operacionais.
        </p>

        <h2>11. Data de vigência</h2>
        <p>Última atualização: 12 de abril de 2026.</p>
      </div>
    </main>
  );
}
